import type { KdsStationResponse } from '@ordr-as/ordr-service-types/epos';
import Spinner from '../../components/Spinner';
import type { OrdrWsConnectionState } from '../../utils/OrdrWebSocketClient';
import KdsToolbar from './KdsToolbar';
import type { StationSelection } from './StationDropdown';
import './animations.css';

type Props = {
  loading: boolean;
  // toolbar
  stations: KdsStationResponse[];
  selection: StationSelection;
  onSelectStation: (selection: StationSelection) => void;
  connectionState: OrdrWsConnectionState;
  recentOpen: boolean;
  onToggleRecent: () => void;
  // regions
  onBoardClick: (e: React.MouseEvent) => void;
  board: React.ReactNode;
  detail: React.ReactNode;
  aux: React.ReactNode;
};

/**
 * The board chrome: toolbar over a board region with a detail and an aux side panel. Pure layout —
 * all interaction state lives in {@link useKdsBoard}; this only places what it is handed.
 */
const BoardLayout = ({
  loading,
  stations,
  selection,
  onSelectStation,
  connectionState,
  recentOpen,
  onToggleRecent,
  onBoardClick,
  board,
  detail,
  aux,
}: Props) => {
  if (loading) {
    return <Spinner className="m-auto mt-6 w-8 h-8" />;
  }

  return (
    <div className="relative flex flex-col h-full overflow-hidden bg-grey-lightest">
      <KdsToolbar
        stations={stations}
        selection={selection}
        onSelect={onSelectStation}
        connectionState={connectionState}
        recentOpen={recentOpen}
        onToggleRecent={onToggleRecent}
      />

      <div className="flex flex-1 min-h-0">
        <div className="flex-1 min-w-0 overflow-y-auto px-4 pb-5" onClick={onBoardClick}>
          {board}
        </div>
        {detail}
        {aux}
      </div>
    </div>
  );
};

export default BoardLayout;
